import {InputAdornment, Stack, TextField, ToggleButtonGroup, Typography} from "@mui/material";
import {Navigate, useParams} from "react-router";
import {appSession} from "../../../TR3AD.ts";
import WidgetHeader from "../../../widgets/WidgetHeader.tsx";
import {appStyles} from "../../../AppStyles.ts";
import {
    StyledAlphaFilterToggleButton,
    StyledInputBase,
    StyledSearch,
    StyledSearchIconWrapper
} from "../../AppStyledComponents.tsx";
import {useState} from "react";

function UXResourceManager() {
    const { networkUID, typeKey, defKey } = useParams();

    const LEFT_1 = "ABCDEFGHIJKLM".split("");
    const LEFT_2 = "NOPQRSTUVWXYZ".split("");
    const SPAN = "!#1";

    // One selection across A–Z + !#1
    const [activeKey, setActiveKey] = useState<string>("A");

    // Dataset-wide search (runs BEFORE results filter)
    const [datasetSearch, setDatasetSearch] = useState<string>("");

    // Results filter (filters returned results AFTER dataset search + alpha selection)
    const [resultsFilter, setResultsFilter] = useState<string>("");

    const getCount = (index: number) => 1 + index * 5;

    // TODO: replace with real computed counts
    const filteredCount = 0;
    const spanCount = 42;

    return (
        <Stack direction="column" width="100%" minHeight="100vh">
            {appSession.activeSession() === false ? (
                <Navigate to="/" />
            ) : (
                <Stack direction="column" spacing={1} width="99%" >
                    <WidgetHeader
                        title={`Resources: ${typeKey}-${defKey}`}
                        breadcrumbs={[
                            {
                                display: "Networks",
                                linkTo: `/networks/`,
                                activeView: false
                            },
                            {
                                display: String(networkUID),
                                linkTo: `/networks/${networkUID}`,
                                activeView: false
                            },
                        {
                            display: "Resources",
                            linkTo: `/networks/${networkUID}`,
                            activeView: false
                        },
                        {
                            display: String(typeKey),
                            linkTo: `/networks/${networkUID}/resources/${typeKey}`,
                            activeView: false
                        },
                        {
                            display: String(defKey),
                            linkTo: "",
                            activeView: true
                        }]}
                    />
                    <Stack direction="row" spacing={2} width="100%" alignItems="stretch">
                        <Stack sx={appStyles.alphaNumberFilterLeftRail}>
                            <Stack direction="column" alignItems="center" spacing={0}>
                                <StyledSearch>
                                    <StyledSearchIconWrapper>
                                        <img src="/images/search_white.svg" width={16} />
                                    </StyledSearchIconWrapper>
                                    <StyledInputBase
                                        placeholder="Search"
                                        value={datasetSearch}
                                        onChange={(e) => setDatasetSearch(e.target.value)}
                                        inputProps={{ "aria-label": "search" }}
                                    />
                                </StyledSearch>
                                <Stack sx={appStyles.alphaNumberDatasetSearchDivider}></Stack>
                                {/* A–Z rails */}
                                <Stack direction="row" spacing={1} sx={appStyles.alphaNumberFilterAlphaRailRow}>
                                    {/* A–M */}
                                    <ToggleButtonGroup
                                        orientation="vertical"
                                        value={activeKey}
                                        exclusive
                                        onChange={(_, v) => v && setActiveKey(v)}
                                        sx={appStyles.alphaNumberToggleGroupVertical}
                                    >
                                        {LEFT_1.map((k, idx) => (
                                            <StyledAlphaFilterToggleButton
                                                key={k}
                                                value={k}
                                                sx={appStyles.alphaNumberToggleButton}
                                            >
                                                <span className="rv-pill">
                                                    <span className="rv-label">{k}</span>
                                                    <span className="rv-count">{getCount(idx)}</span>
                                                </span>
                                            </StyledAlphaFilterToggleButton>
                                        ))}
                                    </ToggleButtonGroup>

                                    {/* N–Z */}
                                    <ToggleButtonGroup
                                        orientation="vertical"
                                        value={activeKey}
                                        exclusive
                                        onChange={(_, v) => v && setActiveKey(v)}
                                        sx={appStyles.alphaNumberToggleGroupVertical}
                                    >
                                        {LEFT_2.map((k, idx) => (
                                            <StyledAlphaFilterToggleButton
                                                key={k}
                                                value={k}
                                                sx={appStyles.alphaNumberToggleButton}
                                            >
                                                <span className="rv-pill">
                                                    <span className="rv-label">{k}</span>
                                                    <span className="rv-count">{getCount(idx + LEFT_1.length)}</span>
                                                </span>
                                            </StyledAlphaFilterToggleButton>
                                        ))}
                                    </ToggleButtonGroup>
                                </Stack>

                                {/* Footer divider + spanning button */}
                                <Stack sx={appStyles.alphaNumberFooterContainer}>
                                    <ToggleButtonGroup
                                        orientation="horizontal"
                                        value={activeKey}
                                        exclusive
                                        onChange={(_, v) => v && setActiveKey(v)}
                                        sx={appStyles.alphaNumberToggleGroupSpan}
                                    >
                                        <StyledAlphaFilterToggleButton
                                            value={SPAN}
                                            sx={[
                                                appStyles.alphaNumberToggleButton,
                                                appStyles.alphaNumberToggleButtonSpan,
                                                appStyles.alphaNumberToggleButtonFooter,
                                            ]}
                                        >
                                            <span className="rv-pill">
                                                <span className="rv-label">{SPAN}</span>
                                                <span className="rv-count">{spanCount}</span>
                                            </span>
                                        </StyledAlphaFilterToggleButton>
                                    </ToggleButtonGroup>
                                </Stack>
                            </Stack>
                        </Stack>

                        {/* CENTER: results panel grows */}
                        <Stack spacing={1} sx={appStyles.alphaNumberCenter}>
                            <Stack sx={appStyles.alphaNumberResultsPanel} direction="column">
                                <Stack direction="row" spacing={1} alignItems="center" sx={appStyles.alphaNumberFilterRow}>
                                    <TextField
                                        size="small"
                                        placeholder="Filter results"
                                        value={resultsFilter}
                                        onChange={(e) => setResultsFilter(e.target.value)}
                                        sx={appStyles.alphaNumberFilterField}
                                        fullWidth
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <img
                                                        src="/images/search_white.svg"
                                                        height={16}
                                                        style={{ opacity: 0.75 }}
                                                    />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Stack>

                                <Typography sx={appStyles.alphaNumberFilterCount}>
                                    {filteredCount} results
                                </Typography>
                            </Stack>
                        </Stack>
                    </Stack>

                </Stack>
            )}
        </Stack>
    );
}

export default UXResourceManager;
